/**
 * assets/complete-your-kit.js
 * Renders the "Completa tu kit" cards for any .rodar-kit-section on the page,
 * using assets/kits-index.json (generated by generate_and_upload_kit_widget.py).
 *
 * After a successful add, refreshCartUI() fetches /cart.js and dispatches a
 * 'cart:update' CustomEvent shaped the way Horizon's own cart-icon.js and
 * component-cart-items.js expect (confirmed by reading those files directly:
 * cart-icon reads event.detail.data.itemCount, cart-items-component reads
 * event.detail.data.sections -- absent here, so it falls back to
 * sectionRenderer.renderSection() and re-fetches the drawer's real HTML).
 */
(function () {
  function formatMoney(amount) {
    var n = parseFloat(amount);
    if (isNaN(n)) return '';
    var fixed = n.toFixed(2);
    var parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + parts.join('.') + ' MXN';
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderCard(component) {
    var card = document.createElement('div');
    card.className = 'rodar-kit-card';
    card.innerHTML =
      '<a href="/products/' + component.handle + '" class="rodar-kit-card-link">' +
        '<img src="' + component.image + '" alt="' + escapeHtml(component.title) + '" loading="lazy">' +
        '<span class="rodar-kit-card-title">' + escapeHtml(component.title) + '</span>' +
        '<span class="rodar-kit-card-price">' + formatMoney(component.price) + '</span>' +
      '</a>' +
      '<button type="button" class="rodar-kit-card-add" data-variant-id="' + component.variant_id + '" data-qty="' + component.qty + '">Agregar</button>';
    return card;
  }

  function fetchCart() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart.js').then(function (res) {
      return res.json();
    });
  }

  function refreshCartUI() {
    // Horizon's cart-icon.js and component-cart-items.js both listen on
    // document for 'cart:update' and read event.detail.resource / event.detail.data.
    // Without a real itemCount they zero out the bubble, and without sections
    // HTML cart-items-component falls back to sectionRenderer.renderSection(),
    // which is exactly what we want here since we don't have rendered HTML.
    fetchCart()
      .then(function (cart) {
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'complete-your-kit',
              data: { itemCount: cart.item_count, source: 'complete-your-kit' },
            },
          })
        );
      })
      .catch(function (err) {
        console.error('Completa tu kit: failed to refresh cart UI', err);
      });
  }

  function addToCart(items, onDone) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (data) {
            throw new Error((data && data.description) || 'cart/add.js failed');
          });
        }
        return res.json();
      })
      .then(function (data) {
        onDone(null, data);
      })
      .catch(function (err) {
        onDone(err);
      });
  }

  function initSection(container, indexData) {
    var groupId = container.dataset.kitGroup;
    var currentVariantId = String(container.dataset.currentVariantId || '');
    var group = indexData[groupId];
    if (!group || !group.components || group.components.length < 2) return;

    var missing = group.components.filter(function (c) {
      return String(c.variant_id) !== currentVariantId;
    });
    if (missing.length === 0) return;

    var grid = container.querySelector('.rodar-kit-grid');
    var feedback = container.querySelector('.rodar-kit-feedback');

    missing.forEach(function (c) {
      grid.appendChild(renderCard(c));
    });

    container.removeAttribute('hidden');

    grid.addEventListener('click', function (e) {
      var btn = e.target.closest('.rodar-kit-card-add');
      if (!btn) return;
      btn.disabled = true;
      var originalText = btn.textContent;
      btn.textContent = 'Agregando...';
      addToCart(
        [{ id: parseInt(btn.dataset.variantId, 10), quantity: parseInt(btn.dataset.qty, 10) || 1 }],
        function (err) {
          if (err) {
            btn.textContent = 'Error, reintenta';
            btn.disabled = false;
            return;
          }
          btn.textContent = 'Agregado ✓';
          refreshCartUI();
        }
      );
    });

    var addAllBtn = container.querySelector('.rodar-kit-add-all');
    if (addAllBtn) {
      addAllBtn.addEventListener('click', function () {
        addAllBtn.disabled = true;
        addAllBtn.textContent = 'Agregando...';
        var items = missing.map(function (c) {
          return { id: parseInt(c.variant_id, 10), quantity: c.qty || 1 };
        });
        addToCart(items, function (err) {
          if (err) {
            addAllBtn.textContent = 'Error, reintenta';
            addAllBtn.disabled = false;
            return;
          }
          addAllBtn.textContent = 'Piezas agregadas ✓';
          feedback.textContent = 'Listo, revisa tu carrito para completar el kit.';
          refreshCartUI();
        });
      });
    }
  }

  function start() {
    var containers = document.querySelectorAll('.rodar-kit-section[data-kit-group]');
    if (containers.length === 0) return;
    var indexUrl = containers[0].dataset.indexUrl;
    if (!indexUrl) return;

    fetch(indexUrl)
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        containers.forEach(function (c) {
          initSection(c, data);
        });
      })
      .catch(function (err) {
        console.error('Completa tu kit: failed to load kits-index.json', err);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
